module.exports = __webpack_public_path__ + "img/client-7.1a7f6ec0.webp";